export default __webpack_public_path__ + "static/public-speaking-bee-62821ca2e0725f2f400e283187a56723.png";